import { Identifiable } from './utilityTypes';
import { generateId } from './generate-id';

export function createIdentifiable<T>(data: T, length = 16): Identifiable<T> {
  return {...data, temporaryUuid: generateId(length)};
}
